import { useState } from 'react';
import './SettingsPanel.css';

export default function SettingsPanel() {
    const [activeTab, setActiveTab] = useState('general');

    const tabs = [
        { id: 'general', label: 'General' },
        { id: 'security', label: 'Security' },
        { id: 'blockchain', label: 'Blockchain' },
        { id: 'notifications', label: 'Notifications' },
    ];

    return (
        <div className="settings-panel">
            <div className="settings-tabs glass">
                {tabs.map(tab => (
                    <button
                        key={tab.id}
                        className={`tab-btn ${activeTab === tab.id ? 'active' : ''}`}
                        onClick={() => setActiveTab(tab.id)}
                    >
                        {tab.label}
                    </button>
                ))}
            </div>

            <div className="settings-content glass">
                {activeTab === 'general' && (
                    <div className="settings-section">
                        <h3>General Configuration</h3>
                        <div className="form-grid">
                            <div className="form-group">
                                <label>Minimum Order Amount (USDT)</label>
                                <input type="number" defaultValue={100} />
                            </div>
                            <div className="form-group">
                                <label>Service Fee (%)</label>
                                <input type="number" defaultValue={2.5} />
                            </div>
                            <div className="form-group">
                                <label>Maintenance Mode</label>
                                <label className="switch">
                                    <input type="checkbox" />
                                    <span className="slider round"></span>
                                </label>
                            </div>
                        </div>
                    </div>
                )}

                {activeTab === 'security' && (
                    <div className="settings-section">
                        <h3>Security Settings</h3>
                        <div className="form-grid">
                            <div className="form-group full-width">
                                <label>Admin IP Whitelist (Comma separated)</label>
                                <textarea defaultValue="127.0.0.1, ::1" rows={3} />
                            </div>
                            <div className="form-group">
                                <label>Rate Limit (Requests/min)</label>
                                <input type="number" defaultValue={60} />
                            </div>
                            <div className="form-group">
                                <label>Session Timeout (Minutes)</label>
                                <input type="number" defaultValue={30} />
                            </div>
                        </div>

                        <div className="danger-zone">
                            <h4>Danger Zone</h4>
                            <button className="danger-btn">Change Admin Password</button>
                        </div>
                    </div>
                )}

                {/* Placeholders for other tabs */}
                {(activeTab === 'blockchain' || activeTab === 'notifications') && (
                    <div className="settings-placeholder">
                        <p>Configuration options coming soon...</p>
                    </div>
                )}

                <div className="settings-footer">
                    <button className="save-btn">Save Changes</button>
                </div>
            </div>
        </div>
    );
}
